"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DDPCancel = exports.DDPError = void 0;
const DDPError_1 = __importDefault(require("./DDPError"));
exports.DDPError = DDPError_1.default;
class DDPCancel extends DDPError_1.default {
    constructor(message = 'Action was canceled') {
        super('cancel', message);
        this.isCancel = true;
    }
}
exports.DDPCancel = DDPCancel;
//# sourceMappingURL=errors.js.map